export const responsivePageCss = `
:host([responsive-page]) .scene{height:auto!important;max-height:none!important;overflow:visible!important}
:host([responsive-page]) .image-safe-box:has(>.page-blocks>.page-block>nav),
:host([responsive-page]) .image-safe-box[data-block-kind="button"]{overflow:visible;min-height:44px}
:host([responsive-page]) nav .layout-button,
:host([responsive-page]) [data-block-kind="button"] .layout-button{min-height:44px!important;min-width:44px;font-size:max(14px,1em);height:auto!important}
:host([responsive-page]) .archive-gallery .layout-button{min-height:44px!important;font-size:max(14px,1em)}
:host([responsive-page]) .card-frame{min-height:var(--responsive-card-height,0px)}
:host([responsive-page]) .card-content-anchor{height:var(--responsive-card-design-height,100%);bottom:auto}
:host([responsive-page]) .card-fill .page-block{margin:0!important;padding:0!important;flex-shrink:0}
:host([responsive-page]) .image-safe-box[data-block-kind="content"]{height:auto!important;min-height:var(--safe-h);overflow:visible}
:host([responsive-page]) .image-safe-box[data-block-kind="content"]>.page-blocks,
:host([responsive-page]) .image-safe-box[data-block-kind="content"]>.page-blocks>.page-block{height:auto}
:host([responsive-page]) .scene[data-responsive-archive]{padding:0!important}
:host([responsive-page]) .scene[data-responsive-archive] .safe-box-layer:empty{display:none}
:host([responsive-page]) .scene[data-responsive-archive]>.panel{position:absolute}
:host([responsive-page]) .archive-flow{position:relative;display:flow-root;width:100%;padding-top:var(--archive-start,24px)}
:host([responsive-page]) .archive-flow>.archive-gallery{margin-top:0!important}
:host([responsive-page]) [data-archive-flow="navigation"]{position:relative!important;left:auto!important;top:auto!important;width:min(420px,calc(100% - 32px))!important;max-width:100%;height:auto!important;min-height:44px;margin:24px auto 0!important;translate:none!important;overflow:visible}
:host([responsive-page]) [data-archive-flow="navigation"]>.page-blocks,
:host([responsive-page]) [data-archive-flow="navigation"]>.page-blocks>.page-block{height:auto!important;text-align:center!important}
:host([responsive-page]) [data-archive-flow="navigation"] .layout-button{font-size:max(14px,1em);padding:12px 20px!important;min-height:44px!important}
:host([responsive-page]) .card-frame{width:min(100%,var(--safe-w))!important;margin-left:clamp(0px,var(--safe-x),calc(100% - min(100%,var(--safe-w))))}
:host([responsive-page]) .scene[data-artwork-device="mobile"] .archive-flow{width:min(640px,calc(100% - 32px));margin-inline:auto;padding-top:clamp(24px,8vw,96px)}
:host([responsive-page]) .scene[data-artwork-device="mobile"] .archive-flow>.archive-gallery{width:100%!important;margin-left:0!important}
:host([responsive-page]) .scene[data-artwork-device="mobile"] .archive-flow .archive-grid{grid-template-columns:minmax(0,1fr)!important;justify-items:center;gap:20px}
:host([responsive-page]) .scene[data-artwork-device="mobile"] .card-artboard{max-width:min(100%,var(--card-mobile-width,390px))}
:host([responsive-page]) [data-archive-flow="heading"]{position:relative!important;left:auto!important;top:auto!important;width:100%!important;height:auto!important;min-height:0;margin:0 0 12px!important;overflow:visible}
:host([responsive-page]) [data-archive-flow="heading"]>.page-blocks,
:host([responsive-page]) [data-archive-flow="heading"]>.page-blocks>.page-block{height:auto!important}
`;

function archiveFlow(scene: HTMLElement) {
  const gallery = [
    ...scene.querySelectorAll<HTMLElement>(".archive-gallery"),
  ].find((element) => element.getClientRects().length);
  if (!gallery) return;
  const small = scene.dataset.artworkDevice === "mobile";
  const headings = [...scene.querySelectorAll<HTMLElement>(".image-safe-box")]
    .filter(
      (box) =>
        box.getClientRects().length &&
        !box.closest(".card,.archive-gallery") &&
        [
          "series",
          "brand",
          "title",
          "subtitle",
          "text",
          "emptyTitle",
          "emptyLabel",
          "emptyBody",
        ].includes(box.dataset.blockKind || ""),
    )
    .sort(
      (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top,
    );
  const navigation = [...scene.querySelectorAll<HTMLElement>("nav")]
    .filter((nav) => nav.getClientRects().length && !nav.closest(".card"))
    .map(
      (nav) =>
        nav.closest<HTMLElement>(".image-safe-box") ??
        nav.closest<HTMLElement>(".page-block")!,
    );
  const flow = document.createElement("div");
  flow.className = "archive-flow";
  if (small)
    for (const heading of headings) {
      heading.dataset.archiveFlow = "heading";
      flow.append(heading);
    }
  flow.append(gallery);
  for (const nav of navigation) {
    nav.dataset.archiveFlow = "navigation";
    flow.append(nav);
  }
  scene.append(flow);
  return () => {
    if (small) return;
    const top = scene.getBoundingClientRect().top;
    const style = getComputedStyle(scene);
    const ratio =
      parseFloat(style.getPropertyValue("--artwork-ratio")) || 0.5625;
    const y = parseFloat(gallery.style.getPropertyValue("--safe-flow-y")) || 0;
    const offset = parseFloat(style.getPropertyValue("--artwork-offset")) || 0;
    const headingBottom = Math.max(
      0,
      ...headings.map(
        (heading) => heading.getBoundingClientRect().bottom - top + 24,
      ),
    );
    flow.style.setProperty(
      "--archive-start",
      `${Math.max(24, headingBottom, (scene.clientWidth * ratio * y) / 100 + offset)}px`,
    );
  };
}

export function installResponsivePage(host: HTMLElement, root: ShadowRoot) {
  host.setAttribute("responsive-page", "");
  const scene = root.querySelector<HTMLElement>(".scene")!;
  const updateArchive = scene.hasAttribute("data-responsive-archive")
    ? archiveFlow(scene)
    : undefined;
  const controller = new AbortController();
  let frame = 0;
  let destroyed = false;
  const visible = (element: HTMLElement) => element.getClientRects().length > 0;
  const navigation = [...root.querySelectorAll<HTMLElement>("nav")]
    .filter((nav) => !nav.closest(".card,dialog"))
    .map((nav) => ({
      nav,
      box:
        nav.closest<HTMLElement>(".image-safe-box") ??
        nav.closest<HTMLElement>(".page-block")!,
    }));
  const growingContent = [
    ...root.querySelectorAll<HTMLElement>(
      ".archive-grid,.prose,.media-player,.compact-audio-player",
    ),
  ].filter((element) => !element.closest(".card,dialog"));
  const update = () => {
    frame = 0;
    if (!host.isConnected) return;
    updateArchive?.();
    for (const cardFrame of root.querySelectorAll<HTMLElement>(".card-frame")) {
      if (!visible(cardFrame)) continue;
      const ratio = getComputedStyle(cardFrame)
        .aspectRatio.split("/")
        .map(Number);
      const designHeight = (cardFrame.clientWidth * ratio[1]) / ratio[0];
      if (!Number.isFinite(designHeight)) continue;
      // Keep percentage pins on their original canvas as the card grows around them.
      cardFrame.style.setProperty(
        "--responsive-card-design-height",
        `${designHeight}px`,
      );
      const boxes = [
        ...cardFrame.querySelectorAll<HTMLElement>(
          ".card-content-anchor .image-safe-box:not([data-shape])",
        ),
      ].filter(visible);
      for (const box of boxes) {
        box.style.removeProperty("translate");
        box.style.removeProperty("height");
      }
      boxes.sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top,
      );
      const placed: DOMRect[] = [];
      let height = designHeight;
      const top = cardFrame.getBoundingClientRect().top;
      for (const box of boxes) {
        const block = box.querySelector<HTMLElement>(".page-block")!;
        const rect = box.getBoundingClientRect();
        box.style.height = `${Math.ceil(Math.max(rect.height, block.scrollHeight))}px`;
        let shift = 0;
        for (const previous of placed) {
          if (previous.left < rect.right && previous.right > rect.left)
            shift = Math.max(shift, previous.bottom + 6 - rect.top);
        }
        if (shift > 0) box.style.translate = `0 ${shift}px`;
        const fitted = box.getBoundingClientRect();
        placed.push(fitted);
        height = Math.max(height, fitted.bottom - top + 12);
      }
      cardFrame.style.setProperty(
        "--responsive-card-height",
        `${Math.ceil(height)}px`,
      );
    }
    for (const { box } of navigation) box.style.removeProperty("translate");
    for (const { nav, box } of navigation.filter(({ nav }) => visible(nav))) {
      const original = nav.getBoundingClientRect();
      let bottom = original.top;
      for (const content of growingContent.filter(visible)) {
        const rect = content.getBoundingClientRect();
        if (
          rect.top <= original.top &&
          rect.left < original.right &&
          rect.right > original.left
        )
          bottom = Math.max(bottom, rect.bottom + 20);
      }
      if (bottom > original.top)
        box.style.translate = `0 ${bottom - original.top}px`;
    }
    const top = scene.getBoundingClientRect().top;
    const artworkRatio =
      parseFloat(getComputedStyle(scene).getPropertyValue("--artwork-ratio")) ||
      0;
    const artworkOffset =
      parseFloat(getComputedStyle(host).getPropertyValue("--artwork-offset")) ||
      0;
    let height = Math.max(
      window.innerHeight - top - window.scrollY,
      scene.clientWidth * artworkRatio + artworkOffset,
    );
    for (const element of root.querySelectorAll<HTMLElement>(
      ".image-safe-box,.page-content .page-block,.panel,nav,.layout-button",
    )) {
      if (!visible(element) || element.closest(".card,dialog")) continue;
      height = Math.max(
        height,
        element.getBoundingClientRect().bottom - top + 24,
      );
    }
    scene.style.minHeight = `${Math.ceil(height)}px`;
  };
  const schedule = () => {
    if (!destroyed && !frame) frame = requestAnimationFrame(update);
  };
  const observer = new ResizeObserver(schedule);
  observer.observe(host);
  for (const element of [
    ...growingContent,
    ...navigation.map((item) => item.nav),
  ])
    observer.observe(element);
  window.addEventListener("resize", schedule, { signal: controller.signal });
  document.fonts?.ready.then(schedule);
  schedule();
  return {
    destroy() {
      destroyed = true;
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      host.removeAttribute("responsive-page");
    },
  };
}
